import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { API_URL, scroll, getValFromLS } from "../../helpers";

import Hdg from "../../components/Hdg";
import Alert from "../../components/Alert";

import Nav from "../Nav";

import HotelNav from "./HotelNav";
import HotelChangesForm from "./HotelChangesForm";

const Changes = () => {
	const [user, setUser] = useState({});
	const [changes, setChanges] = useState([]);
	const [changes2, setChanges2] = useState([]);
	const [, setErrors] = useState([]);
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();

	useEffect(() => {
		const init = async () => {
			const token = getValFromLS("vtoUserToken")
				? getValFromLS("vtoUserToken")
				: "";
			const url = new URL(`${API_URL}/admin/hotelChangesInit`);
			const params = {
				token,
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setChanges(json.pendingChanges);
					setChanges2(json.pendingChanges2);
					setUser({ ...json.user });
					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, []);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/admin/hotelChanges`);
		let data = new FormData(document.getElementById("changes-form"));
		data.append("token", getValFromLS("vtoUserToken"));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				history.push({
					pathname: `/admin/hotel`,
					state: {
						message: {
							type: "success",
							text: json.text,
						},
					},
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Hotel Management" admin={true} />
						<HotelNav selected="changes" />
						<HotelChangesForm
							changes={changes}
							changes2={changes2}
							msg={msg}
							submit={handleSubmit}
						/>
						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={0} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Changes;
